"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _Fetch = _interopRequireDefault(require("@insided/deprecated-preact-components/selector/Fetch"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _FilterOption = _interopRequireDefault(require("./FilterOption"));

var _renderProps = require("../../../libs/renderProps");

var _isArrayOfStrings = require("@insided/control/utils/isArrayOfStrings");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DynamicFilterSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DynamicFilterSelector, _Component);

  var _super = _createSuper(DynamicFilterSelector);

  function DynamicFilterSelector() {
    var _this$props$selectedF;

    var _this;

    (0, _classCallCheck2.default)(this, DynamicFilterSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      data: (_this$props$selectedF = _this.props.selectedFilterItems) !== null && _this$props$selectedF !== void 0 ? _this$props$selectedF : [],
      fetchedItems: [],
      value: '',
      isSelectAll: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFilterOptionSelection", function (payload) {
      var fetchedItems = _this.state.fetchedItems;
      var data = payload.map(function (item) {
        return fetchedItems.filter(function (x) {
          return String(x.id) === String(item);
        })[0];
      });

      _this.setState({
        data: data,
        isSelectAll: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickSelectAll", function () {
      _this.setState(function (prevState) {
        var isSelectAll = !prevState.isSelectAll;
        var data = isSelectAll ? prevState.fetchedItems.filter(function (x) {
          return x.id !== undefined;
        }) : [];
        return {
          isSelectAll: isSelectAll,
          data: data
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItem", function (item) {
      if (item.name === 'separator') {
        return (0, _preact.h)("hr", {
          className: "separator"
        });
      }

      if (item.name === 'title') {
        return (0, _preact.h)("div", {
          className: "overview__filters-box-filter overview__filters-box-filter-title"
        }, item.value);
      }

      var inputType = _this.props.inputType;
      var _this$state = _this.state,
          data = _this$state.data,
          isSelectAll = _this$state.isSelectAll;
      return (0, _preact.h)(_FilterOption.default, {
        item: item,
        key: item.id,
        type: inputType,
        data: data.map(function (y) {
          return String(y.value);
        }),
        onFilterOptionSelection: _this.onFilterOptionSelection,
        isSelectAll: isSelectAll
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderContent", function (loading) {
      if (loading) {
        return (0, _preact.h)("div", {
          className: "loader"
        }, (0, _preact.h)(_assets.default, {
          icon: "loader"
        }));
      }

      var _this$state2 = _this.state,
          fetchedItems = _this$state2.fetchedItems,
          isSelectAll = _this$state2.isSelectAll;
      var normalizedItems = DynamicFilterSelector.normalizeFetchedItems(fetchedItems);

      if (normalizedItems && normalizedItems.length === 0) {
        return (0, _preact.h)("div", {
          className: "overview__filters-box-content-no-results"
        }, "No results found");
      }

      var inputType = _this.props.inputType;
      var selectionLabel = isSelectAll ? 'Deselect all' : 'Select all';
      return (0, _preact.h)("div", null, inputType && inputType !== 'radio' && (0, _preact.h)("p", {
        className: "select-all",
        onClick: _this.onClickSelectAll
      }, selectionLabel), normalizedItems.map(_this.renderItem));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoaded", function (fetchedItems) {
      var _this$props = _this.props,
          onLoad = _this$props.onLoad,
          normalizer = _this$props.normalizer,
          items = _this$props.items,
          id = _this$props.id;
      var _this$state3 = _this.state,
          data = _this$state3.data,
          value = _this$state3.value;

      if (!onLoad) {
        return;
      }

      if (normalizer) {
        fetchedItems = normalizer(fetchedItems);
      }

      if (!value && items) fetchedItems = [].concat((0, _toConsumableArray2.default)(items), (0, _toConsumableArray2.default)(fetchedItems));
      var normalizedItems = DynamicFilterSelector.normalizeFetchedItems(fetchedItems);
      var matchedData = (0, _isArrayOfStrings.isArrayOfStrings)(data) ? DynamicFilterSelector.normalizeFetchedItems(fetchedItems.filter(function (x) {
        return data.includes(x.name);
      })) : data;

      _this.setState(function (prevState) {
        var allItems = [].concat((0, _toConsumableArray2.default)(matchedData), (0, _toConsumableArray2.default)(normalizedItems)).filter(function (item, index, self) {
          return index === self.findIndex(function (x) {
            return x.id === item.id;
          });
        });

        if (allItems.length === prevState.data.length) {
          return {
            fetchedItems: allItems,
            isSelectAll: true,
            data: matchedData
          };
        }

        return {
          fetchedItems: allItems,
          data: matchedData
        };
      });

      onLoad(id, normalizedItems);
    });
    return _this;
  }

  (0, _createClass2.default)(DynamicFilterSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          name = _this$props2.name,
          children = _this$props2.children,
          fetchUrl = _this$props2.fetchUrl,
          _this$props2$isSearch = _this$props2.isSearchable,
          isSearchable = _this$props2$isSearch === void 0 ? true : _this$props2$isSearch;
      var _this$state4 = this.state,
          data = _this$state4.data,
          value = _this$state4.value;
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "overview__filters-box-content"
      }, isSearchable && (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: "Search for ".concat(name),
        value: value,
        onSubmit: function onSubmit() {},
        onInput: function onInput(e) {
          return _this2.setState({
            value: e.target.value
          });
        },
        onClear: function onClear() {
          return _this2.setState({
            value: ''
          });
        }
      }), (0, _preact.h)(_Fetch.default, {
        baseUrl: fetchUrl || '',
        responseKey: DynamicFilterSelector.responseKey(id),
        searchValue: value,
        onLoaded: this.onLoaded
      }, function (_ref) {
        var loading = _ref.loading;
        return _this2.renderContent(loading);
      })), (0, _renderProps.extractRenderPropsChildren)(children)({
        data: data,
        isApplyButtonDisabled: data.length === 0
      }));
    }
  }]);
  return DynamicFilterSelector;
}(_preact.Component);

(0, _defineProperty2.default)(DynamicFilterSelector, "create", function (config) {
  return _objectSpread({
    component: DynamicFilterSelector,
    type: 'filter',
    getPillDisplayValue: function getPillDisplayValue(data) {
      var firstItem = (0, _isArrayOfStrings.isArrayOfStrings)(data) ? data[0] : data[0].name;
      var otherItems = data.length > 1 ? "+".concat(data.length - 1) : '';
      return "".concat(firstItem, " ").concat(otherItems);
    }
  }, config);
});
(0, _defineProperty2.default)(DynamicFilterSelector, "normalizeFetchedItems", function (items) {
  return items.map(function (item) {
    return {
      id: item.id,
      name: item.name,
      avatar: item.avatar,
      value: item.value || item.id,
      icon: Object.keys(item).includes('icon') ? item.icon : undefined
    };
  });
});
(0, _defineProperty2.default)(DynamicFilterSelector, "responseKey", function (filterId) {
  return ['productArea'].includes(filterId) ? 'result' : undefined;
});
var _default = DynamicFilterSelector;
exports.default = _default;